import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";
import { DEFAULT_CONTENT } from "@/data/defaultContent";
import { BUSINESS } from "@/data/business";

const ContentContext = createContext(null);

const merge = (data) => ({
  ...DEFAULT_CONTENT,
  ...data,
  hero: { ...DEFAULT_CONTENT.hero, ...(data?.hero || {}) },
  services: data?.services?.length ? data.services : DEFAULT_CONTENT.services,
  fixed_products: data?.fixed_products?.length ? data.fixed_products : DEFAULT_CONTENT.fixed_products,
  custom_products: data?.custom_products?.length ? data.custom_products : DEFAULT_CONTENT.custom_products,
  contact: { ...DEFAULT_CONTENT.contact, ...(data?.contact || {}) },
});

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/content");
      setContent(merge(data));
    } catch {
      /* keep defaults */
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const c = content.contact || {};
  const business = {
    ...BUSINESS,
    phone: c.phone || BUSINESS.phone,
    phoneDisplay: c.phoneDisplay || BUSINESS.phoneDisplay,
    whatsapp: c.whatsapp || BUSINESS.whatsapp,
    email: c.email || BUSINESS.email,
    address: c.address || BUSINESS.address,
    hours_en: c.hours || BUSINESS.hours_en,
  };
  const waLink = (text) =>
    `https://wa.me/${business.whatsapp}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

  return (
    <ContentContext.Provider value={{ content, business, waLink, loading, refresh }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => {
  const ctx = useContext(ContentContext);
  if (!ctx) throw new Error("useContent must be used within ContentProvider");
  return ctx;
};
